import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import FilterDropdown from '../../filtering/FilterDropdown';

interface AccessTeamsToolbarProps {
    search: string;
    onSearchChange: (value: string) => void;
    scopeFilter: string[];
    onScopeFilterChange: (value: string[]) => void;
    canManageTeams: boolean;
    onAddTeam: () => void;
}

const SCOPE_OPTIONS = [
    { value: 'odo', label: 'ODO' },
    { value: 'practice', label: 'Practice' }
];

// Search box + FilterDropdown copied from AccessUsersToolbar (Access > Users) -
// same component, same props/variant, same placement, so the two Access list
// pages read as one toolbar design. The scope filter is inherently multi-select
// but stays single-valued (see AccessTeams' `scopeFilter[0]`), same convention
// as AccessUsersToolbar's role filter.
export function AccessTeamsToolbar({
    search,
    onSearchChange,
    scopeFilter,
    onScopeFilterChange,
    canManageTeams,
    onAddTeam
}: AccessTeamsToolbarProps) {
    return (
        <div className="flex items-center justify-between gap-4 shrink-0">
            <div className="flex items-center w-[340px] h-11 bg-white border border-gray-200 rounded-xl px-4 shrink-0">
                <MagnifyingGlassIcon className="w-5 h-5 text-gray-400 mr-2 shrink-0" />
                <input
                    type="text"
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="Search teams"
                    className="bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400 w-full"
                />
                {search && (
                    <button
                        type="button"
                        onClick={() => onSearchChange('')}
                        className="ml-2 shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Clear search"
                    >
                        <XMarkIcon className="w-4 h-4" />
                    </button>
                )}
            </div>
            <div className="flex items-center gap-2.5">
                <FilterDropdown
                    title="Scope"
                    options={SCOPE_OPTIONS}
                    selectedOptions={scopeFilter}
                    onChange={onScopeFilterChange}
                    workQueueVariant
                    align="right"
                />
                {canManageTeams && (
                    <button
                        type="button"
                        onClick={onAddTeam}
                        className="bg-black text-white font-semibold px-6 py-2 rounded-xl shadow hover:bg-gray-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        + Add Team
                    </button>
                )}
            </div>
        </div>
    );
}
